import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const getInsuredById = insuredId => getJson(`/insureds/${insuredId}`);

export const refreshInsured = insuredId => putJson(`/insureds/${insuredId}/refresh`);

export const updateInsured = (insuredId, updates) => putJson(`insureds/${insuredId}`, updates);

export const getInsuredOverallStatus = insuredId => getJson(`/insureds/${insuredId}/overall-status`);

export const getInsuredRecords = (insuredId, pageData, filter) => getJson(`/insureds/${insuredId}/records`, pageData, { filter });

export const getAllInsuredRecords = insuredId => getJson(`/insureds/${insuredId}/records/all`);

export const getInsuredEmails = (insuredId, recordId, order, pageData) => {
  if (recordId && recordId !== 'all') {
    return getJson(`/insureds/${insuredId}/emails`, pageData, { record_id: recordId, order });
  }

  return getJson(`/insureds/${insuredId}/emails`, pageData, { order });
};

export const getInsuredAutomatedEmails = (insuredId, recordId, order, pageData) => {
  if (recordId && recordId !== 'all') {
    return getJson(`/insureds/${insuredId}/automated-emails`, pageData, { record_id: recordId, order });
  }

  return getJson(`/insureds/${insuredId}/automated-emails`, pageData, { order });
};

export const mergeInsureds = (insuredId, insuredIdsToMerge) => postJson(`insureds/${insuredId}/insureds`, { insured_ids: insuredIdsToMerge });
